import { createFileRoute, notFound, Outlet } from '@tanstack/react-router';
import { Main, MainPending } from '@/ui/components/main';
import { offersQuery, procurementDetailsQuery } from '@/features/subcontractor-bids/queries';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId',
)({
  staticData: { chatSurface: 'bid_comparison' },
  component: RouteComponent,
  loader: async (opts) => {
    const [, procurement] = await Promise.all([
      opts.context.queryClient.query({
        ...offersQuery(opts.params.workspaceId, opts.params.procurementId),
        staleTime: 'static',
      }),
      opts.context.queryClient.query({
        ...procurementDetailsQuery(opts.params.workspaceId, opts.params.procurementId),
        staleTime: 'static',
      }),
    ]);
    if (!procurement) throw notFound();
  },
  pendingComponent: MainPending,
});

function RouteComponent() {
  return (
    <Main className="flex flex-row">
      <div className="grow flex flex-col min-w-0">
        <Outlet />
      </div>
    </Main>
  );
}
